var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgScaleDown = function SvgScaleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 25,
    height: 36,
    viewBox: "0 0 5.92 8.61",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.02 8.42c-.23.23-.61.24-.84.01a.598.598 0 0 1-.01-.84l.38-.39c.51-.54.97-1.02 1.69-1.53.06-.05.11-.09.14-.13.58-.59.7-.71 1.91.6.17.19.37.39.55.57.29.29.55.56.86.93.21.25.17.62-.08.83-.25.21-.62.18-.83-.07-.29-.35-.53-.59-.79-.86-.16-.16-.33-.33-.58-.6-.37-.41-.19-.53-.5-.31-.61.43-1.04.88-1.52 1.38l-.38.41zM.13 1.16a.589.589 0 0 1 .96-.68l.39.32c.42.35 1.02.85 1.51 1.38.12-.16.26-.32.42-.45.23-.21.66-.66 1.03-1.05l.47-.5c.23-.23.6-.24.83-.01.24.22.24.6.02.83l-.46.49c-.38.4-.83.88-1.11 1.13l-.03.03c-.15.13-.27.3-.36.43-.11.16-.2.29-.34.4-.38.29-.71.29-1.08-.19-.42-.55-1.17-1.17-1.66-1.58-.29-.24-.5-.41-.59-.55z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};

export default SvgScaleDown;